import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';


@Component({
  selector: 'ngx-modal-confirmacao',
  templateUrl: './modal-confirmacao.component.html',
  styleUrls: ['./modal-confirmacao.component.scss']
})
export class ModalCofirmacaoComponent implements OnInit {

  @Input() titleModal: string = 'Confirmação';
  @Input() bodyModal: string = 'Realmente deseja prosseguir com a operação?';
  @Input() confirmBtLabel: string = 'SIM';
  @Input() cancelBtLabel: string = 'NÃO';


  @Output() confirmaEmitter: EventEmitter<void> = new EventEmitter<void>();


  public customLogin = null;


  constructor(
    protected ref: NbDialogRef<ModalCofirmacaoComponent>,
  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;

  }

  confirmar() {
    this.confirmaEmitter.emit();
  }


  cancelar() {
    this.ref.close();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
